import { buildUserData, detectSignupMethod } from '@/datalayer';
import { pushLogin, pushSignUp } from '@/datalayer-events';

/**
 * EU-395 — dispara `sign_up` (1ª criação de conta) ou `login` (usuário já
 * existente) no **retorno do SSO**, a partir do token Keycloak, conforme o spec
 * (itens 3 e 4): o evento sai quando o usuário volta ao app autenticado.
 *
 * O gate é `isJustSignedUp` (flag `signup-welcome`, setada antes do redirect ao
 * registro do KC): cadastro novo → `sign_up`; login recorrente → `login`. Cada
 * evento é deduplicado por `sub` + `auth_time` (DLR-021/022/024).
 *
 * Roda no `KeycloakGate` (fora do `QueryClientProvider`), então o `user_data` é
 * montado SÓ a partir do token: `email`, `first_name`/`last_name` (claim `name`)
 * e `external_id` (= `participant_id` = `sub`). Telefone/endereço/db/ge ainda não
 * coletados nesta fase → `null` (premissa do spec: "endereço apenas se já
 * coletado nesta fase").
 */
export function fireAuthDataLayerEvent(
  tokenParsed: Record<string, unknown> | undefined,
  isJustSignedUp: boolean
): void {
  if (!tokenParsed) return;
  const sub = typeof tokenParsed.sub === 'string' ? tokenParsed.sub : '';
  if (!sub) return;

  const authTime =
    typeof tokenParsed.auth_time === 'number'
      ? tokenParsed.auth_time
      : typeof tokenParsed.iat === 'number'
        ? tokenParsed.iat
        : 0;

  const method = detectSignupMethod(tokenParsed);
  const email = typeof tokenParsed.email === 'string' ? tokenParsed.email : null;
  const fullName = typeof tokenParsed.name === 'string' ? tokenParsed.name : null;
  const userData = buildUserData({ email, fullName, participantId: sub });

  if (isJustSignedUp) {
    pushSignUp({
      method,
      participant_id: sub,
      user_data: userData,
      dedupeKey: `eureca_dl_sign_up:${sub}:${authTime}`,
    });
  } else {
    pushLogin({
      method,
      participant_id: sub,
      user_data: userData,
      dedupeKey: `eureca_dl_login:${sub}:${authTime}`,
    });
  }
}
